/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IPermitToWorkTypeRequest } from '../models/permit-to-work-type.model';

export class LoadPermitToWorkTypes {
  static readonly type = '[Permit To Work Type] Load';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllPermitToWorkTypes {
  static readonly type = '[Permit To Work Type] Load All';
}

export class GetPermitToWorkTypeById {
  static readonly type = '[Permit To Work Type] Get By Id';
  constructor(public id: string) {}
}

export class CreatePermitToWorkType {
  static readonly type = '[Permit To Work Type] Create';
  constructor(public permitType: IPermitToWorkTypeRequest) {}
}

export class UpdatePermitToWorkType {
  static readonly type = '[Permit To Work Type] Update';
  constructor(public permitType: IPermitToWorkTypeRequest) {}
}

export class SetPermitToWorkTypeActive {
  static readonly type = '[Permit To Work Type] Set Active';
  constructor(
    public id: string,
    public isActive: boolean
  ) {}
}

export class DeletePermitToWorkType {
  static readonly type = '[Permit To Work Type] Delete';
  constructor(public id: string) {}
}

export class ClearCurrentPermitToWorkType {
  static readonly type = '[Permit To Work Type] Clear Current';
}
